class RotatingText extends HTMLElement {
  constructor() {
    super();

    this.normalText = this.getAttribute("data-text-normal");
    this.boldText = this.getAttribute("data-text-bold");

    this.createSpinner();
  }

  createSpinner() {
    const text =
      this.normalText + " " + this.boldText + (this.boldText ? " " : "");
    const chars = text.split("");
    this.innerHTML = "";
    this.style.setProperty("--char-count", chars.length);

    const normalchars = this.normalText.split("");
    const boldchars = this.boldText.split("");

    for (let c = 0; c < normalchars.length; c++) {
      this.innerHTML += `<span aria-hidden="true" class="char" style="--char-index: ${c};">${chars[c]}</span>`;
    }

    if (boldchars.length) {
      for (let c = 0; c < boldchars.length; c++) {
        this.innerHTML += `<span aria-hidden="true" class="char bold" style="--char-index: ${
          c + normalchars.length + 1
        };">${boldchars[c]}</span>`;
      }
    }

    this.innerHTML += `<span class="sr-only">${text}</span>`;
  }
}

customElements.define("rotating-text", RotatingText);
